import router from '@/router'
import {AxiosError} from 'axios'

export const STORAGE_PREFIX = 'mlm_'

export const keyBy = (pk: string, collection: any[]): { [idx: number]: any } => {
  const keyedCollection: { [idx: number]: any } = {}
  collection.forEach(item => keyedCollection[item[pk]] = item)

  return keyedCollection
}

export const showError = (error: AxiosError): void => {
  console.log(error.response)
}

export const setCookie = (name: string, value: string) => {
  const now = new Date()
  const time = now.getTime()
  const expireTime = time + 1000*36000
  now.setTime(expireTime)
  document.cookie = `${name}=${value};expires=${now.toUTCString()};path=/`
}

export const setLocalStorageItem = (itemName: string, itemValue: string) => {
  localStorage.setItem(`${STORAGE_PREFIX}${itemName}`, itemValue)
}

export const getLocalStorageItem = (itemName: string) => {
  return localStorage.getItem(`${STORAGE_PREFIX}${itemName}`)
}

export function getCookie(name: string) {
  const match_list = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'),
  )
  return match_list ? decodeURIComponent(match_list[1]) : undefined
}

export function parseBackendErrors(error: any): string[] {
  const response = error?.response
  const data = response?.data

  if (process.env.NODE_ENV !== 'production') {
    console.warn('parseBackendErrors →', response?.status, data)
  }

  if (Array.isArray(data?.errors)) {
    return data.errors.map((msg: unknown) =>
        typeof msg === 'string' ? msg : String(msg)
    )
  }

  if (data?.errors && typeof data.errors === 'object') {
    return Object.values(data.errors).flatMap((messages) =>
        Array.isArray(messages) ? messages : [String(messages)]
    )
  }

  if (typeof data?.message === 'string') {
    return [data.message]
  }

  return ['Произошла ошибка']
}
